import LauncherLoading from "@/containers/pages/General/Loading/LoadingPage";
import { Box, BoxProps, useTheme } from "@mui/material";
import { forwardRef } from "react";

const MainBox = forwardRef<HTMLDivElement, { isLoading?: boolean } & BoxProps>(
  ({ isLoading = false, children, ...other }, ref) => {
    const theme = useTheme();

    return isLoading ? (
      <LauncherLoading />
    ) : (
      <Box
        sx={{
          flexGrow: 1,
          padding: theme.spacing(3),
          boxSizing: "border-box",
        }}
        {...other}
      >
        {children}
      </Box>
    );
  }
);

export default MainBox;
